import { render, staticRenderFns } from "./corporateDetails.vue?vue&type=template&id=4f8d4b63&scoped=true&lang=en&"
import script from "./corporateDetails.vue?vue&type=script&lang=js&"
export * from "./corporateDetails.vue?vue&type=script&lang=js&"
import style0 from "./corporateDetails.vue?vue&type=style&index=0&id=4f8d4b63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8d4b63",
  null
  
)

export default component.exports